import CONFIGURACIONES from "../../../../util/constants";
import OWASP from "../../../../util/owasp";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";

import { Http } from "../../../../helpers/Http";
import { useLocation, useOutletContext } from "react-router-dom";

const MantProducto = ({mant, idEdit, createData, updateData, closeSection, idRef, setIdRef, 
    endPointShow, setEndPointUpdate, showCreate, showEdit, init, tiposCredito}) => {
    const location = useLocation();
    const { showSpinnerLoader } = useOutletContext();

    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({mode: "onChange"});
    const [title, setTitle] = useState(CONFIGURACIONES.INIT.STRING);
    useEffect(() => {
        reset();
        showSpinnerLoader();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSeg', lastSegment);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            init();
            setIdRef((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            showData((lastSegment === 'new'? CONFIGURACIONES.INIT.ID_EDIT:lastSegment));
            setTitle((lastSegment === 'new')? `Creando ${mant}`:`Editando ${mant}`);
        }
    }, [location.pathname]);

    const onSubmit1 = (form) => {
        // console.log('form', form);
        if (idRef === CONFIGURACIONES.INIT.ID_EDIT) {
            createData(form);
        } else {
            updateData(form);
        }
    };

    const showData = async (ref) => {
        console.log('ref', ref);
        
        if (ref !== CONFIGURACIONES.INIT.ID_EDIT) {
            // console.log('entras...', endPointShow);
            if (endPointShow === CONFIGURACIONES.INIT.STRING || !showEdit) { closeSection(); }
            await Http().get(endPointShow)
            .then(async (rpta) => {
                if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                    // setLinks(rpta.data.links);
                    setEndPointUpdate(rpta.data.links.find(link => link.rel === CONFIGURACIONES.REFS.UPDATE)?.href || null);
                    // let cmpLink = rpta.data.links.find(link => link.rel === CONFIGURACIONES.INIT.HREF_LOGS);
                    // console.log('cmpLink', cmpLink);
                    // await loadLogData(cmpLink?.href);
                    loadForm(rpta.data);
                }
            });
        } else {
            if (!showCreate) { closeSection(); }
        }
    };

    const loadForm = (object) => {
        setValue('nombre', object.nombre);
        setValue('tasaMinInteres', object.tasaMinInteres);
        setValue('tasaMaxInteres', object.tasaMaxInteres);
        setValue('tipoCreditoId', object.tipoCreditoId);
    };

    return (
        <>
        { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
            <div className="card-content">
                <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                    <div className="row">
                        <div className="col-xs-12 col-md-11"> 
                            <h5 className="card-title font-weight-bold">{title}</h5>
                            <div className="row">
                                <div className="col-sm-12 col-md-5">
                                    <div className="form-group">
                                        <label htmlFor="nombre" className="control-label col-form-label">Nombre <span className="text-danger">*</span></label>
                                        <input 
                                            {...register("nombre", {
                                                required: OWASP.REQUIRED,
                                                pattern: {
                                                    value: OWASP.VALIDATIONS.GENERAL,
                                                    message: OWASP.MESSAGES.DEFAULT
                                                }
                                            })}
                                            type="text" className="form-control" id="nombre" placeholder="" />
                                        <small className="invalid-feedback"> { errors.nombre && errors.nombre.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="tasaMinInteres" className="control-label col-form-label">Tasa Mínima <span className="text-danger">*</span></label>
                                        <div className="input-group">
                                            <input 
                                                {...register("tasaMinInteres", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_PERCENTAGES,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                type="text" className="form-control" id="tasaMinInteres" placeholder="" />
                                            
                                            <div className="input-group-append">
                                                <span className="input-group-text">%</span>
                                            </div>
                                        </div>
                                        <small className="invalid-feedback"> { errors.tasaMinInteres && errors.tasaMinInteres.message }</small>           
                                    </div>
                                </div>

                                <div className="col-sm-12 col-md-2">
                                    <div className="form-group">
                                        <label htmlFor="tasaMaxInteres" className="control-label col-form-label">Tasa Máxima <span className="text-danger">*</span></label>
                                        <div className="input-group">
                                            <input 
                                                {...register("tasaMaxInteres", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_PERCENTAGES,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                type="text" className="form-control" id="tasaMaxInteres" placeholder="" />
                                            
                                            <div className="input-group-append">
                                                <span className="input-group-text">%</span>
                                            </div>
                                        </div>
                                        <small className="invalid-feedback"> { errors.tasaMaxInteres && errors.tasaMaxInteres.message }</small>           
                                    </div>
                                </div>
                            
                                <div className="col-sm-12 col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="tipoCreditoId" className="control-label col-form-label">Tipo de Crédito <span className="text-danger">*</span></label>
                                        <select 
                                            {...register("tipoCreditoId", {
                                                required: OWASP.REQUIRED,
                                            })} className="form-control" id="tipoCreditoId" 
                                            placeholder="" defaultValue={""}
                                        >
                                            <option value="" disabled>Seleccione</option>
                                            {
                                                tiposCredito.map((el, index) => (
                                                    <option key={index} value={el.id}>{el.nombre}</option>
                                                ))
                                            }
                                        </select>
                                        <small className="invalid-feedback"> { errors.tipoCreditoId && errors.tipoCreditoId.message }</small>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    
                    <div className="action-form mt-1 d-flex justify-content-start">
                        <div className="form-group mb-0 text-left">
                            <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                <i className="mdi mdi-arrow-left"></i> Descartar
                            </WaveButton>
                            { idRef == CONFIGURACIONES.INIT.ID_EDIT && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Guardar
                            </WaveButton>}

                            { idRef > CONFIGURACIONES.INIT.NUMBER && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                <i className="mdi mdi-content-save-settings"></i> Modificar
                            </WaveButton>}
                        </div>
                    </div>
                </form>
            </div>
            </>
        }
        </>
    )
}
export default MantProducto;